module.exports = __webpack_public_path__ + "img/active-layer3.25e13f68.png";